import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteLayoutType } from '../../../../../../../common/redux/features/siteConfig/selectors';
import { API_TYPES } from '../../../../../ApiDisplay';
import { EXAMPLE_TYPES } from '../../../../types';
import { ExamplesPresenter } from '../../ExamplesPresenter/ExamplesPresenter';

export const OperationExample = ({ example, name, JSLayoutType }) => {
  const layoutType = useSelector(selectSiteLayoutType);

  return (
    <React.Fragment>
      <ExamplesPresenter
        displayName={name}
        renderFor={
          layoutType === API_TYPES.JS || JSLayoutType
            ? EXAMPLE_TYPES.JS_FUNCTION
            : EXAMPLE_TYPES.REQUEST
        }
        example={example}
      />
      {example.response && (
        <ExamplesPresenter
          example={example}
          displayName={name}
          renderFor={EXAMPLE_TYPES.RESPONSE}
        />
      )}
    </React.Fragment>
  );
};

OperationExample.propTypes = { example: PropTypes.any, name: PropTypes.string };
